import type { CreateTagInput, GetTagsResponse, UpdateTagInput } from "@montatec/contracts";
import { del, get, patch, post } from "../../../lib/fetch";

export const tagsService = {
    get:    async (categoryId: number) => await get<GetTagsResponse>(`/api/providers/templates/categories/${categoryId}/tags`).then(res => res.data),
    create: async (categoryId: number, data: CreateTagInput) => await post(`/api/providers/templates/categories/${categoryId}/tags`, data),
    update: async (categoryId: number, tagId: number, data: UpdateTagInput) => await patch(`/api/providers/templates/categories/${categoryId}/tags/${tagId}`, data),
    delete: async (categoryId: number, tagId: number) => await del(`/api/providers/templates/categories/${categoryId}/tags/${tagId}`)
}